import { useQuery } from "@tanstack/react-query";
import { request } from "../../../services/axios.service";
import { apiUrls } from "../../api-urls";

const get = async (paging?: TPaging) => {
  const response: TServerResponse = await request({
    url: apiUrls.homeBanner.FETCH_BANNERS,
    method: "GET",
    params: { ...paging },
  });
  return response;
};

export const useHomeBannersQuery = (paging: TPaging) => {
  return useQuery({
    queryKey: [apiUrls.homeBanner.FETCH_BANNERS, paging],
    queryFn: () => get(paging),
  });
};
